import { INBOUND_SETTLEMENT_UNIT_TYPE_FLAG, PartnerSettlementStatisticItem, PartnerSettlementStatisticsReq, ServiceTypeKey } from '@/services/settlement/settlementManagement/types'
import {
  useGetDailySettlementStatistics,
  useGetPartnerSettlementStatistics,
} from '@/services/settlement/settlementManagement/useSettlementManagementQueries'
import { groupInboundSettlementDetails } from '@/pages/settlement/SettlementManagement/utils/groupInboundSettlementDetails'
import { useFeatureFlag } from '@/services/feature/useFeatureQueries'

type SettlementStatisticsDetailReq = Omit<PartnerSettlementStatisticsReq, 'serviceType'> & {
  serviceType: ServiceTypeKey
}
export const useSettlementStatisticsDetailQuery = ({ partnerId, settlementMonth, serviceType, country, ...rest }: SettlementStatisticsDetailReq) => {
  const isAllServiceType = serviceType === 'ALL'

  // LP9182 — 국가 필터(전체=undefined)를 전체 탭(daily)·per-cost 탭(partner) 양쪽 쿼리에 전달
  const { data: dailySettlements, ...dailySettlementsQueries } = useGetDailySettlementStatistics(
    { partnerId, settlementMonth, country },
    isAllServiceType,
  )
  const { data: partnerSettlements, ...partnerSettlementsQueries } = useGetPartnerSettlementStatistics(
    { partnerId, settlementMonth, serviceType: serviceType as PartnerSettlementStatisticsReq['serviceType'], country, ...rest },
    !isAllServiceType,
  )

  const rawData = isAllServiceType ? dailySettlements?.items : partnerSettlements?.items

  // LP8519: 박스단위 입고 정산 feature flag. OFF(또는 미배포) 면 집계 없이 raw items → 레거시 INBOUND 컬럼과 정합 (fail-safe 기본 false)
  const { data: isInboundSettlementUnitTypeEnabled } = useFeatureFlag(INBOUND_SETTLEMENT_UNIT_TYPE_FLAG)

  // INBOUND 탭의 BOX/PCS를 서버의 productAxis와 settlementDate 기준으로 집계한다.
  // 다른 ServiceType 탭은 기존 동작을 유지하고, flag OFF 면 INBOUND 도 집계하지 않는다.
  const data =
    serviceType === 'INBOUND' && isInboundSettlementUnitTypeEnabled
      ? groupInboundSettlementDetails((rawData ?? []) as PartnerSettlementStatisticItem[])
      : rawData

  const queries = isAllServiceType ? dailySettlementsQueries : partnerSettlementsQueries
  return {
    data: data || [],
    pageInfo: partnerSettlements?.pageInfo,
    ...queries,
  }
}
